import clsx from 'clsx'
import flatMap from 'lodash/flatMap'
import map from 'lodash/map'
import uniqBy from 'lodash/uniqBy'
import React, { FC, useContext, useMemo } from 'react'

import { SliderWithArrowsAndIndicator } from '@Components/Slider/SliderWithArrowsAndIndicator'
import { PaymentIcon } from '@Domains/Checkout/Steps/Payment/Components/PaymentIconFactory/PaymentIconFactory'
import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './PaymentIcons.module.scss'

export const PaymentIcons: FC<{ className?: string, enableSlider?: boolean }> = ({ className, enableSlider }) => {
  const { paymentMethods, store } = useContext(MetadataContext)
  const hidePostFinancePayment = useSplitTest('post_finance_payment_v1', 'b')
  const paymentIcons = useMemo(
    () => uniqBy(flatMap(paymentMethods, 'icons'), 'name').filter(icon => !(hidePostFinancePayment
          && ['19', '20'].includes(store.id)
          && (icon.name === 'postfinancecw_postfinancecard')
    )),
    [hidePostFinancePayment, paymentMethods, store.id],
  )

  if (enableSlider) {
    return (
      <SliderWithArrowsAndIndicator arrowsClassName={styles.paymentIconsArrows} hideIndicator sliderClassName={clsx(styles.paymentIconsV2, className)}>
        {map(paymentIcons, icon => (
          <div key={icon.name} className={styles.paymentIconWrapper}>
            <PaymentIcon className={styles[icon.name]} name={icon.name} url={icon.logo.url} />
          </div>
        ))}
      </SliderWithArrowsAndIndicator>
    )
  }

  return (
    <div className={clsx(styles.paymentIcons, className)}>
      {map(paymentIcons, icon => <PaymentIcon key={icon.name} className={styles[icon.name]} name={icon.name} url={icon.logo.url} />)}
    </div>
  )
}
